export const EXPORT_MAX_SIZE = 10000;
export const SUPPORT_URL = 'https://talentview.co/support';
export const SUPPORT_EMAIL = 'support@talentview.co';
export const TERMS_OF_SERVICE_URL = 'https://talentview.co/terms-of-service';
export const DEFAULT_PAGING_LIMIT = 25;
export const DEFAULT_PAGING_OFFSET = 0;
